import ApiService from "@/common/api/api.service";
//import helpers from "@/common/utils/helpers";

import CronogramaEtapa from "./accordion/CronogramaEtapa";
import CronogramaFinanceiro from "./accordion/CronogramaFinanceiro";
import Entregaveis from "./accordion/Entregaveis";
import RecursoHumano from "./accordion/RecursoHumano";
import Investimento from "./accordion/Investimento";
import Rubricas from "./accordion/Rubricas";
let endpoint = "Proposta";

const PropostaService = {
    async listarPropostas($idCompany, filter = "", perPage, page) {
        const path = `Proposta?EmpresaId=${$idCompany}&text=${filter}&TamanhoDaPagina=${perPage}&NumeroDaPagina=${page}`
        return await ApiService.get(path);
    },

    async listarPropostaEmpresaProponente($idCompany, filter = "", perPage, page) {
        const path = `PropostaEmpresaProponente?EmpresaId=${$idCompany}&text=${filter}&TamanhoDaPagina=${perPage}&NumeroDaPagina=${page}`
        return await ApiService.get(path);
    },

    async listarPropostaEmpresaExecutora($idCompany, filter = "", perPage, page) {
        const path = `PropostaEmpresaExecutora?EmpresaId=${$idCompany}&text=${filter}&TamanhoDaPagina=${perPage}&NumeroDaPagina=${page}`
        return await ApiService.get(path);
    },

    async PropostaEmpresaCooperada($idCompany, filter = "", perPage, page) {
        const path = `PropostaEmpresaCooperada?EmpresaId=${$idCompany}&text=${filter}&TamanhoDaPagina=${perPage}&NumeroDaPagina=${page}`
        return await ApiService.get(path);
    },

    listarPropostasAgrupadas($idCompany, filter = "", perPage, page) {
        const path = `Proposta/agrupadas?EmpresaId=${$idCompany}&Titulo=${filter}&TamanhoDaPagina=${perPage}&NumeroDaPagina=${page}`
        return ApiService.get(path);
    },

    setEndpoint: function (endpointSelecionado) {
        endpoint = endpointSelecionado;
        let accordion = [
            CronogramaFinanceiro,
            RecursoHumano,
            Investimento,
            Rubricas];

        accordion.forEach(function (item) {
            item.setEndpoint(endpoint);
        });
    },

    salvarDescricaoTecnica: function (form) {
        if (form.descricaoTecnica.id) {
            let f = form.descricaoTecnica;
            return ApiService.put(`${endpoint}/descricao-tecnica`, f);
        } else {
            return ApiService.post(`${endpoint}/descricao-tecnica`, form);
        }
    },

    buscarProposta: function (id) {
        return ApiService.get(`${endpoint}/${id}`);
    },

    fetch($idCompany, filter = "", perPage, page) {
        return ApiService.get(`${endpoint}?EmpresaId=${$idCompany}&text=${filter}&TamanhoDaPagina=${perPage}&NumeroDaPagina=${page}`);
    },

    atualizarProponente: function (form) {
        return ApiService.put(`${endpoint}/empresa-proponente`, form);
    },
    adicionarEmpresa: function (form, tipo) {
        return ApiService.post(`${tipo == 'executoras' ? 'Proposta' : 'PropostaEmpresaProponente'}/empresas-${tipo}`, form);
    },
    removerEmpresa: function (form, tipo) {
        return ApiService.delete(`${tipo == 'executoras' ? 'Proposta' : 'PropostaEmpresaProponente'}/empresas-${tipo}`, form);
    },
    buscarEmpresas: function (id) {
        return ApiService.get(`Proposta/empresas/?propostaId=${id}`);
    },

    buscarDespesa: Rubricas.buscar,
    salvarDespesa: Rubricas.salvar,
    removerDespesa: Rubricas.deletar,

    buscarRH: RecursoHumano.buscar,
    removerRH: RecursoHumano.deletar,
    salvarRH: RecursoHumano.salvar,

    buscarEtapa: CronogramaEtapa.buscar,
    removerEtapa: CronogramaEtapa.deletar,
    salvarEtapa: CronogramaEtapa.salvar,

    buscarDesembolsos: CronogramaFinanceiro.buscar,
    removerDesembolso: CronogramaFinanceiro.deletar,
    salvarDesembolso: CronogramaFinanceiro.salvar,
    getEmpresas: CronogramaFinanceiro.getEmpresas,

    buscarEntregavel: Entregaveis.buscar,
    removerEntregavel: Entregaveis.deletar,
    salvarEntregavel: Entregaveis.salvar,


    buscarInvestimento: Investimento.buscar,
    buscarInvestimentoExecutora: Investimento.buscarExecutora,
    salvarInvestimento: Investimento.salvar,

    aprovarProposta: function (id) {
        return ApiService.post(`PropostaEmpresaProponente/aprovar?propostaProponenteId=${id}`);
    },

    congelar(id, congelar) {
        if (congelar)
            return ApiService.put(`Proposta/congelar?id=${id}`);
        else
            return ApiService.put(`Proposta/retomar?id=${id}`);
    },

    apagar(id) {
        return ApiService.delete(`Proposta?id=${id}`);
    },

    temMovimentacao(id) {
        return ApiService.get(`Proposta/tem-movimentacao/${id}`);
    },

    relatorioConsolidadoPDF(id, consolidado) {
        return ApiService.downloadFile(`${endpoint}/relatorio-consolidado-pdf?id=${id}&consolidado=${consolidado}`);
    },

    relatorioConsolidadoExcel(id, consolidado) {
        return ApiService.get(`${endpoint}/relatorio-consolidado-excel?id=${id}&consolidado=${consolidado}`)
    },

    baixarAnexo5(id, consolidado = false, usarRaiz = false) {
        return ApiService.get(`${usarRaiz ? 'proposta' : endpoint}/anexo5?id=${id}&Consolidado=${consolidado}`);
    },

    baixarArquivoDescricaoTecnica(propostaId, arquivoId) {
        return ApiService.downloadFile(`proposta/descricao-tecnica/download-arquivo?propostaId=${propostaId}&arquivoId=${arquivoId}`);
    },

};

export default PropostaService;
